export function prepareArray(array, level) {
  let returnString = '';
  if (typeof array !== 'undefined') {
    Object.keys(array).forEach((key) => {
      const value = array[key];
      if (Array.isArray(value)) {
        returnString += ' '.repeat(level * 5) + key + ":\n";
        returnString += prepareArray(value, level + 1);
      } else {
        returnString += ' '.repeat(level * 5) + key + '=' + value + "\n";
      }
    });
  }
  return returnString;
}
  
export function prepareJSON(jsonString, arrow = false) {
    const array = JSON.parse(jsonString);
    return prepareArray(array, 0, arrow);
}
  

export function prepareArrowArray(array, level) {
  let returnString = '';
  if (array !== null && typeof array === 'object') {
      Object.keys(array).forEach((key) => {
          const value = array[key];
          if (Array.isArray(value)) {
              returnString += ' '.repeat(level * 5) + key + ":\n";
              returnString += prepareArrowArray(value, level + 1);
          } else if (typeof value === 'object') {
              returnString += ' '.repeat(level * 5) + key + ":\n";
              returnString += prepareArrowArray(value, level + 1);
          } else {
              returnString += ' '.repeat(level * 5) + key + ' => ' + value + '\n';
          }
      });
  }
  return returnString;
}

export function prepareArrowJSON(jsonString) {
  const array = JSON.parse(jsonString);
  return prepareArrowArray(array, 0);
}


export function targetActiveTransfersDecode(jsonString, campaignCodes ={}) {

    // Функция для обработки JSON строки
    const loadJson = (str) => {
        try {
            return JSON.parse(str);
        } catch (e) {
            return {};
        }
    };

    let maxActiveTransfers = loadJson(jsonString);
    if (!maxActiveTransfers.campaigns) maxActiveTransfers.campaigns = [];
    if (!maxActiveTransfers.limit) maxActiveTransfers.limit = '';

    let campaignsList = '';
    maxActiveTransfers.campaigns.forEach((campaignId, key) => {
        let campaignCode = `"${campaignCodes[campaignId]}"` || '';
        // Если код кампании найден, добавляем его в строку, иначе удаляем из массива
        if (campaignCode !== '') {
            campaignsList = campaignsList !== '' ? campaignsList + '+' + campaignCode : campaignCode;
        } else {
            delete maxActiveTransfers.campaigns[key];
        }
    });

    let str = campaignsList !== '' || maxActiveTransfers.limit !== '' ? campaignsList + '=' + maxActiveTransfers.limit : '';
    return  str;
}

export function targetActiveTransfersEncode(str, campaignCodes = {}) {
    // Создаем обратное отображение кодов кампаний на их ID
    const reverseCampaignCodes = Object.entries(campaignCodes).reduce((acc, [id, code]) => {
        acc[code] = id;
        return acc;
    }, {});

    const result = {
        campaigns: [],
        limit: ''
    };

    if (str) {
        const [campaignsList, limit] = str.split('=');
        
        if (campaignsList) {
            const campaigns = campaignsList.split('+');
            result.campaigns = campaigns.map(campaign => {
                const code = campaign.replace(/"/g, ''); // Удаляем кавычки
                return reverseCampaignCodes[code] || code;
            });
        }

        if (limit !== undefined) {
            result.limit = limit;
        }
    }

    return JSON.stringify(result);
}


export function TimeDecode(jsonString) {
  let json = JSON.parse(jsonString);
  let result = '';

  for (let keyWeekday in json) {
      if (getWeekday(parseInt(keyWeekday)) !== '') {
          result += getWeekday(parseInt(keyWeekday)) + ': ';
      } else {
          continue;
      }

      let analyzerow = json[keyWeekday];
      for (let key = 0; key < analyzerow.length; key++) {
          let row = analyzerow[key];
          result += `${row.from.hours}:${row.from.minutes}-${row.to.hours}:${row.to.minutes}`;
          
          if (key !== (analyzerow.length - 1)) {
              result += ', ';
          }
      }

      if (keyWeekday !== Object.keys(json).pop()) {
          result += '\n';
      }
  }
  
  return result;
}

export function TimeEncode(str) {
    const TIMES = {};
    const T = str ? str.split('\n') : [];

    for (let i = 0; i < T.length; i++) {
        const analyzerow = T[i].trim();
        const key = findWeekday(analyzerow);
        if (key === -1) continue;

        if (!TIMES[key]) TIMES[key] = [];

        const intervals = analyzerow.substring(analyzerow.indexOf(":") + 1).trim().split(',');
        
        for (let j = 0; j < intervals.length; j++) {
            const [from, to] = intervals[j].split('-').map(time => time.trim());

            if (!isValidTime(from) || !isValidTime(to)) continue;

            const row = {
                from: { hours: from.slice(0, 2), minutes: from.slice(-2) },
                to: { hours: to.slice(0, 2), minutes: to.slice(-2) }
            };

            TIMES[key].push(row);
        }
    }

    return JSON.stringify(TIMES);
}

function findWeekday(str) {
    for (let i = 1; i <= 7; i++) {
        if (str.toLowerCase().includes(getWeekday(i).toLowerCase())) {
            return i;
        }
    }
    return -1;
}

function isValidTime(time) {
    if (time.length !== 5 || time[2] !== ':') return false;

    const hours = parseInt(time.slice(0, 2), 10);
    const minutes = parseInt(time.slice(-2), 10);

    return !isNaN(hours) && !isNaN(minutes) &&
           hours >= 0 && hours <= 24 &&
           minutes >= 0 && minutes <= 59;
}

function getWeekday(key) {
  let targetLanguage = localStorage.getItem('targetlanguage');
  
  if (targetLanguage === 'ru') {
      switch (key) {
          case 1: return 'понедельник';
          case 2: return 'вторник';
          case 3: return 'среда';
          case 4: return 'четверг';
          case 5: return 'пятница';
          case 6: return 'суббота';
          case 7: return 'воскресенье';
          default: return '';
      }
  } else {
      switch (key) {
          case 1: return 'monday';
          case 2: return 'tuesday';
          case 3: return 'wednesday';
          case 4: return 'thursday';
          case 5: return 'friday';
          case 6: return 'saturday';
          case 7: return 'sunday';
          default: return '';
      }
  }
}



export function RepeatcallsDecode(jsonString) {
  let json = JSON.parse(jsonString);
  let result = '';

  json.forEach((repeatcall, index) => {
      result += repeatcall.interval;
      if (repeatcall.priority !== 1) {
          result += '=' + repeatcall.priority;
      }
      if (index !== json.length - 1) {
          result += ',';
      }
  });

  return result;
}

export function TerminalstatusesDecode(jsonString) {
  let json = JSON.parse(jsonString);
  let result = '';

  json.forEach((terminalstatus, index) => {
      result += terminalstatus.finalstatus;
      if (terminalstatus.leadgroup !== '') {
          result += '=' + terminalstatus.leadgroup;
      }
      if (index !== json.length - 1) {
          result += '\n';
      }
  });

  return result;
}